import React, { useCallback, useState } from 'react';
import { fetchMetricsText } from '../auth/metricsFetch';
import { formatLocalTime } from '../utils/metricsRates';

export function MetricsRawDump() {
  const [text, setText] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fetchedAt, setFetchedAt] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const body = await fetchMetricsText();
      setText(body);
      setFetchedAt(formatLocalTime(new Date()));
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to fetch /metrics');
      setText('');
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <div className="metrics-raw-panel">
      <h3 className="metrics-raw-title">Raw /metrics</h3>
      <div className="metrics-raw-toolbar">
        <button type="button" className="button primary" onClick={load} disabled={loading}>
          {loading ? 'Loading…' : 'Load / refresh'}
        </button>
        {fetchedAt && <span className="metrics-raw-meta">Last fetch: {fetchedAt}</span>}
      </div>
      {error && <p className="metrics-raw-error">{error}</p>}
      <pre className="metrics-raw-pre" aria-label="Prometheus metrics text">
        {text || (loading ? '…' : 'Manual refresh only — click “Load / refresh” for full Prometheus text.')}
      </pre>
    </div>
  );
}
